import useLeadsScript from './useLeadsScript'
import useAddressRelatedScript from './useAddressRelatedScript'
import useTelecomContractRelatedScript from './useTelecomContractRelatedScript'

const useScripts = () => {
  const { leadScripts } = useLeadsScript()
  const { addressRelatedScripts } = useAddressRelatedScript()
  const { telecomScripts } = useTelecomContractRelatedScript()
  const scripts = { ...leadScripts, ...addressRelatedScripts, ...telecomScripts }

  return {
    scripts,
  }
}

export default useScripts
